import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const PlusCircleIcon = ({ color = '#B5BCBD', size = '16px', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill={color}
      d="M12.7 8.7V7.3c0-.2-.1-.3-.2-.5s-.3-.1-.5-.1H9.3V4c0-.2-.1-.3-.2-.5s-.3-.2-.4-.2H7.3c-.1 0-.3.1-.4.2s-.2.3-.2.5v2.7H4c-.2 0-.3.1-.5.2-.1.1-.2.3-.2.4v1.3c0 .2.1.3.2.5.2.2.3.2.5.2h2.7V12c0 .2.1.3.2.5s.3.2.5.2h1.3c.2 0 .3-.1.5-.2s.2-.3.2-.5V9.3H12c.2 0 .3-.1.5-.2s.2-.3.2-.4zM16 8c0 1.5-.4 2.8-1.1 4-.7 1.2-1.7 2.2-2.9 2.9-1.2.7-2.5 1.1-4 1.1s-2.8-.4-4-1.1c-1.2-.7-2.2-1.7-2.9-2.9S0 9.5 0 8s.4-2.8 1.1-4S2.8 1.8 4 1.1 6.5 0 8 0s2.8.4 4 1.1 2.2 1.7 2.9 2.9c.7 1.2 1.1 2.5 1.1 4z"
    />
  </svg>
);

PlusCircleIcon.propTypes = propTypes;

export default PlusCircleIcon;
